import { adjustedFlowActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case adjustedFlowActionTypes.ADJUST_FLOW:
            return action.value;
        case adjustedFlowActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default: return state;
    }
};